<template>
    <div class="flex flex-col gap-4">
        <div v-for="group in 2" :key="group" class="flex flex-col gap-2">
            <div class="h-3 w-20 animate-pulse rounded bg-gray-light"></div>
            <div v-for="item in 2" :key="item" class="flex flex-col gap-2 rounded-card border border-panel-border bg-white px-3 py-2.5">
                <div class="h-3 w-24 animate-pulse rounded bg-gray-light"></div>
                <div class="h-3 w-full animate-pulse rounded bg-gray-light"></div>
                <div class="h-3 w-2/3 animate-pulse rounded bg-gray-light"></div>
            </div>
        </div>
    </div>
</template>
